import CustomerOrderCodBadge from 'domains/customer-order/atoms/cod-badge'
import CustomerOrderPaymentStatusBadge from 'domains/customer-order/atoms/payment-status-badge'
import CustomerOrderRefundStatusBadge from 'domains/customer-order/atoms/refund-status-badge'
import CustomerOrderShipmentProgressStatusBadge from 'domains/customer-order/atoms/shipment-progress-status-badge'
import CustomerOrderStatusBadge from 'domains/customer-order/atoms/status-badge'
import PropTypes from 'prop-types'
import React from 'react'
import { Card, CardHeader, Table } from 'reactstrap'
import PriceUtil from 'utils/price-util'
import TimeUtil from 'utils/time-util'


const propTypes = {
  order: PropTypes.shape({
    id                        : PropTypes.number,
    number                    : PropTypes.string,
    order_date                : PropTypes.string,
    expires_at                : PropTypes.string,
    status                    : PropTypes.string,
    payment_status            : PropTypes.string,
    payment_method_name       : PropTypes.string,
    shipment_progress_status  : PropTypes.string,
    refund_status             : PropTypes.string,
    is_cod                    : PropTypes.bool,
    item_price_total          : PropTypes.number,
    item_tax_total            : PropTypes.number,
    item_discount_total       : PropTypes.number,
    shipment_cost_total       : PropTypes.number,
    shipment_discount_total   : PropTypes.number,
    shipment_insurance_total  : PropTypes.number,
    discount_total            : PropTypes.number,
    sub_total                 : PropTypes.number,
    total                     : PropTypes.number,
    discount_code             : PropTypes.string,
    payment_method_rate_total : PropTypes.number
  })
}

/**
 * Presenting Customer Order Detail Information
 * @param {object} order Customer Order
 */
const CustomerOrderDetailCard = ({ order }) => (
  <Card>
    <CardHeader>
      <div>
        <span className='small text-uppercase text-light font-weight-bolder'>
          { 'Customer Order' }
        </span>
        <h2>
          <span className='mr-3'>{ order.number }</span>
          <small>
            <CustomerOrderStatusBadge status={ order.status } />
          </small>
        </h2>
      </div>
    </CardHeader>

    <Table responsive hover size={ 'sm' } className='mb-0'>
      <tbody>
        <tr>
          <th scope='row'>ID</th>
          <td>{ order.id }</td>
        </tr>
        <tr>
          <th scope='row'>Order Date</th>
          <td>{ TimeUtil.format(order.order_date, 'DD MMM YY, HH:mm:ss') }</td>
        </tr>
        <tr>
          <th scope='row'>Expired At</th>
          <td>{ TimeUtil.format(order.expires_at, 'DD MMM YY, HH:mm:ss') }</td>
        </tr>
        <tr>
          <th scope='row'>Voucher Code</th>
          <td>{ order.discount_code || '-' }</td>
        </tr>
        <tr>
          <th scope='row'>Payment Status</th>
          <td>
            <CustomerOrderPaymentStatusBadge status={ order.payment_status } />
          </td>
        </tr>
        <tr>
          <th scope='row'>Shipment<br/>Progress</th>
          <td>
            <CustomerOrderShipmentProgressStatusBadge status={ order.shipment_progress_status } />
          </td>
        </tr>
        <tr>
          <th scope='row'>Refund Status</th>
          <td>
            <CustomerOrderRefundStatusBadge status={ order.refund_status } />
          </td>
        </tr>
        <tr>
          <th scope='row'>Is COD</th>
          <td>
            <CustomerOrderCodBadge isCod={ order.is_cod } />
          </td>
        </tr>
        <tr>
          <th scope='row'>Payment<br/>Method</th>
          <td className='text-wrap'>{ order.payment_method_name }</td>
        </tr>
        <tr>
          <th scope='row'>Payment Fee</th>
          <td>{ PriceUtil.format(order.payment_method_rate_total) }</td>
        </tr>

        <tr>
          <td colSpan='2'></td>
        </tr>

        <tr>
          <th scope='row'>Item<br/>Price Total</th>
          <td>{ PriceUtil.format(order.item_price_total) }</td>
        </tr>
        <tr>
          <th scope='row'>Item<br/>Tax Total</th>
          <td>({ PriceUtil.format(order.item_tax_total) })</td>
        </tr>
        <tr>
          <th scope='row'>Item<br/>Discount Total</th>
          <td>({ PriceUtil.format(order.item_discount_total) })</td>
        </tr>
        <tr>
          <th scope='row'>Shipment<br/>Insurance Total</th>
          <td>{ PriceUtil.format(order.shipment_insurance_total) }</td>
        </tr>
        <tr>
          <th scope='row'>Shipment<br/>Cost Total</th>
          <td>{ PriceUtil.format(order.shipment_cost_total) }</td>
        </tr>
        <tr>
          <th scope='row'>Shipment<br/>Discount Total</th>
          <td>({ PriceUtil.format(order.shipment_discount_total) })</td>
        </tr>

        <tr>
          <td colSpan='2'></td>
        </tr>

        <tr>
          <th scope='row'>Sub Total</th>
          <td>{ PriceUtil.format(order.sub_total) }</td>
        </tr>
        <tr>
          <th scope='row'>Discount Total</th>
          <td>({ PriceUtil.format(order.discount_total) })</td>
        </tr>
        <tr>
          <th scope='row'>Grand Total</th>
          <td>{ PriceUtil.format(order.total) }</td>
        </tr>
      </tbody>
    </Table>
  </Card>
)

CustomerOrderDetailCard.propTypes = propTypes

export default CustomerOrderDetailCard
